export class Size {
    constructor(w, h) {
        this.width = w ? w : 0;
        this.height = h ? h : 0;
    }
    isReal() {
        return isFinite(this.width) && isFinite(this.height);
    }
    toString() {
        return `Size(${this.width} ${this.height})`;
    }
}
